import * as React from "react";

function Close(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" {...props}>
      <path
        d="M8.5 6.926L14.723.703 16.5 2.481l-6.223 6.222 6.223 6.223-1.777 1.777L8.5 10.481l-6.223 6.222L.5 14.926l6.223-6.223L.5 2.481 2.277.703 8.5 6.926z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoClose = React.memo(Close);
export default MemoClose;
